module.exports = __webpack_public_path__ + "img/hang-tv.e7899d86.png";